import { parseParamToString } from '~/utils/parseParamToString';

export function resolveFlowPlanId(urlPlan: string | null, storePlanId: string | undefined): string {
  const fromUrl = urlPlan?.trim() ?? '';
  const fromEnv = String(import.meta.env.VITE_ARIDE_DEFAULT_PLAN ?? '').trim();
  return fromUrl || fromEnv || parseParamToString(storePlanId) || '';
}
